import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
// import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "../firebase";
// Async thunk for fetching jobs
export const fetchJobs = createAsyncThunk(
  'jobs/fetchJobs',
  async (_, { getState, rejectWithValue }) => {
    try {
      // await fetchAndActivate(remoteConfig);
      // const baseUrl = process.env.REACT_APP_API_JOB_URL;
      const baseUrl = process.env.REACT_APP_BACKEND_URL;
      // const baseUrl="https://ems-backend-dev-275113975046.us-central1.run.app/hrm"
      
      console.log('Fetching jobs data...'); 
      const response = await axios.get(`${baseUrl}/get_all_jobs?Status=Published`);
      console.log('Jobs data received:', response.data); 
      return response.data;
    } catch (error) {
      console.error('Error fetching jobs:', error); 
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const { jobs } = getState();
      // Only allow the fetch if status is idle or failed
      if (jobs.status === 'loading' || jobs.status === 'succeeded') {
        console.log('Fetch prevented: already loading or succeeded'); 
        return false;
      }
      return true;
    },
  }
);

const initialState = {
  jobs: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
  uniqueLocations: [],
  uniqueJobRoles: [],
  lastFetchTime: null
};

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    resetJobsStatus: (state) => {
      state.status = 'idle';
    },
    forceRefreshJobs: (state) => {
      // Force refresh regardless of current state
      state.status = 'idle';
      state.lastFetchTime = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        console.log('Setting status to loading'); 
        state.status = 'loading';
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        console.log('Setting status to succeeded'); 
        // state.status = 'succeeded';
         state.status = 'failed';
        if (Array.isArray(action.payload)) {
          state.jobs = action.payload;
          
          // Extract unique locations and job roles
          state.uniqueLocations = [...new Set(action.payload.map(job => job.Location))].filter(Boolean);
          state.uniqueJobRoles = [...new Set(action.payload.map(job => job.JobRole))].filter(Boolean);
          
          // Record when we last fetched the data
          state.lastFetchTime = Date.now();
        }
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        console.log('Setting status to failed'); 
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

// Export actions
export const { resetJobsStatus, forceRefreshJobs } = jobsSlice.actions;

// Selectors
export const selectAllJobs = (state) => state.jobs.jobs;
export const selectJobById = (state, jobId) => state.jobs.jobs.find(job => job.ID === jobId);
export const selectJobsStatus = (state) => state.jobs.status;
export const selectJobsError = (state) => state.jobs.error;
export const selectUniqueLocations = (state) => state.jobs.uniqueLocations;
export const selectUniqueJobRoles = (state) => state.jobs.uniqueJobRoles;
export const selectLastFetchTime = (state) => state.jobs.lastFetchTime;

export default jobsSlice.reducer;